/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Fri Jan 13 2023 3:16:54 PM
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React from 'react';
import { TextField, InlineError } from '@shopify/polaris';
import { RenderLabelTooltip } from './render-label-tooltip';

export const RenderTextField = (field: Object) => {
  const [emptyValue, setEmptyValue] = React.useState();

  const { input } = field;
  let { value } = input;
  value = _.isNil(value) ? value : value.toString();

  return (
    <div>
      <RenderLabelTooltip label={field.label} tooltip={field.tooltip} />
      <TextField
        id={field.input.name}
        value={value}
        type={field.type}
        min={field.min}
        onChange={field.input.onChange}
        onFocus={field.input.onFocus}
        placeholder={field.placeholder ? field.placeholder : ''}
        onBlur={() => {
          if (!input.value || _.isEmpty(input.value)) {
            setEmptyValue(true);
          } else {
            setEmptyValue(false);
          }
          field.input.onBlur();
        }}
        {...field.anotherProps}
      />
      {field.helperText ? <p style={{ marginTop: '4px' }}>{field.helperText}</p> : ''}
      {!!field.meta.error && emptyValue ? <InlineError message={field.meta.error} /> : ''}
    </div>
  );
};
